<template>
    <div>
        <d-form id="kickbiteForm" @submit.prevent="updateConnection">
            <div class="form-group">
                <label>App ID (aid)</label>
                <d-input required v-model="appId" />
            </div>
            <div class="form-group">
                <label>Market ID (mid)</label>
                <d-input required v-model="marketId" />
            </div>
            <d-button theme="success" type="submit">Update</d-button>
            <d-button class="btn btn-danger ml-3" @click="disconnect()">Disconnect</d-button>
        </d-form>
    </div>
</template>

<script>
    import { KickbiteIntegration, ErrorService, WebsiteService } from '@/main';
    import notification from '@/mixins/notification';
    import * as Sentry from "@sentry/browser"

    export default {
        name: "KickbiteUpdateConnectionForm",

        props: ['configuration', 'websiteId'],

        mixins: [notification],

        data() {
            return {
              appId: '',
              marketId: '',
            }
        },

        methods: {
            async updateConnection() {
                try {
                    await KickbiteIntegration.updateConnection(
                        this.websiteId,
                        this.appId,
                        this.marketId
                    )

                    this.showNotification('success', 'Alert', 'Kickbite successfully updated!')
                    this.$router.go()
                } catch(e) {
                    this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                    console.log(e)
                    Sentry.captureException(e);
                }
            },
            async disconnect() {
                try {
                    await WebsiteService.disconnectIntegration(this.$route.params.id, 'kickbite')
                    this.showNotification('success', 'Alert', 'Integration successfully disconnected!')
                    this.$router.go()
                } catch (e) {
                    this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                    console.log(e)
                    Sentry.captureException(e);
                }
            }
        },

        created() {
            this.appId = this.configuration.app_id
            this.marketId = this.configuration.market_id
        },
    }
</script>
